import OptionItem from './OptionItem.js';
import Menu from './Menu.js';
import MenuList from './MenuList.js';
import SingleValue from './SingleValue.js';

const Components = { Option: OptionItem, Menu, MenuList, SingleValue };

export { Components as default };
//# sourceMappingURL=index.js.map
